/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import { default as rootReducer } from './reducers/index'
import { default as whitelist } from './reducers/whitelist'

export default filterActions(rootReducer, whitelist)
